import React from 'react';
import { FormSection } from 'redux-form';
import styled from 'styled-components';

import CustomControlSection from 'components/AdvancedSettings/CustomControlSection';
import { SettingsHelper } from 'components/Shared/SettingsGroup';
import { SCAFFOLDING, SETTINGS_INPUTS, INPUT_TOGGLES } from 'theme';

const StyledSettingsHelper = styled(SettingsHelper)`
    margin: 0 -${SETTINGS_INPUTS.PADDING.X} 1px;
    padding: ${SCAFFOLDING.GUTTER_FACTOR(0.5)} ${SETTINGS_INPUTS.PADDING.X} ${SCAFFOLDING.GUTTER_FACTOR(0.5)};
    padding-left: ${`calc(${parseInt(SETTINGS_INPUTS.PADDING.X, 10) + 10}px + ${INPUT_TOGGLES.WIDTH})`};
    background-color: ${SETTINGS_INPUTS.BG.SUB};

    & + * {
        margin-top: 1px;
    }
`;

const CustomControlsSection = () => {
    return (
        <FormSection name="custom">
            <StyledSettingsHelper>
                Toggle individual controls and settings. More information about the different control positions can be
                viewed{' '}
                <a
                    href="https://developers.google.com/maps/documentation/javascript/controls#ControlPositioning"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    here
                </a>
                .
            </StyledSettingsHelper>
            <CustomControlSection name="zoom" title="Zoom Control" label="Show Control" />
            <CustomControlSection name="mapType" title="Map Type Control" label="Show Control" />
            <CustomControlSection name="streetView" title="Street View Control" label="Show Control" />
            <CustomControlSection
                name="rotate"
                title="Rotate Control"
                label="Show Control"
                help="You will only see this control when you zoom into certain locations while in satellite mode (e.g. Santa Cruz, CA)."
            />
            <CustomControlSection
                name="scale"
                title="Scale Control"
                label="Show Control"
                help="This control appears in the bottom right hand side of the map next to the Terms of Use."
            />
            <CustomControlSection name="fullscreen" title="Fullscreen Control" label="Show Control" />
        </FormSection>
    );
};

export default CustomControlsSection;
